// extracted by mini-css-extract-plugin
module.exports = {"selected":"SelectButtons_healthgenom_selected__vepaL"};